import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { BillerInterface } from "@tae/interfaces";
import { StorageService } from "@tae/services";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
import { TaggingService } from "../../../services/tagging.service";
import { PictureBasicCardInterface } from "src/app/interfaces/basic-card.interface";

@Component({
    selector: "app-companies",
    templateUrl: "./companies.component.html",
    styleUrls: ["./companies.component.scss"],
    standalone: false
})
export class CompaniesComponent {
  public get billers(): BillerInterface[] {
    const data = this.ctrlRecharge.billers;
    if (!data?.length) this.router.navigateByUrl("/captura");
    return this.buildBillers(data);
  }

  constructor(
    private ctrlRecharge: CtrlRechargeService,
    private router: Router,
    private storageService: StorageService,
    private taggingService: TaggingService
  ) {
    const pageView: PageViewInferface = {
      url: "recarga_celular/seleccion_compania",
      canalBanco: "supermovil",
      titulo: "recarga_celular|seleccion_compania",
      subsection1: "recarga_celular",
      userId: "",
      marca: "",
      entorno: this.storageService.get("ENV"),
      versionApp: "",
      event: "PageView",
    };
    this.taggingService.setPageView(pageView);
  }

  private buildBillers(_billers: BillerInterface[]): BillerInterface[] {
    const order = ['0004', '0005', '0006', '1008'];
    const secondary = _billers.filter(_item => !order.includes(_item.billerId))
    let primary = [];
    for (const _id of order) {
      const find = _billers.find(_item => _item.billerId === _id);
      if (find) {
        primary.push(find);
      }
    }
    return primary.concat(secondary);
  }

  public onSelected(_data: BillerInterface): void {
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "seleccion_compania",
      etiqueta: _data.name,
      canalBanco: "supermovil",
      url: "recarga_celular/seleccion_compania",
      userID: "",
    };

    this.taggingService.setEvent(action);
    this.ctrlRecharge.biller = _data;
    this.onBack(true);
  }

  public onBack(_selected?: boolean): void {
    if (!_selected) {
      this.ctrlRecharge.biller = undefined;
    }
    this.ctrlRecharge.amount = undefined;
    this.router.navigateByUrl("/captura");
  }

  public getPicture(_biller: BillerInterface): PictureBasicCardInterface {
    return this.ctrlRecharge.getPicture(_biller.billerId);
  }
}
